import React from "react";
import { Helmet } from "react-helmet-async";

export default function KaliciEngel() {
  return (
    <div>
      <Helmet>
        <title>
          Kalıcı Engel Tazminatı: Trafik Kazası Sonrası Haklarınız Nelerdir?
        </title>
        <meta
          name="description"
          content="Trafik kazası sonucu kalıcı bir engelle karşılaştınız mı? Kalıcı engel tazminatı nedir, nasıl talep edilir ve hukukumuzda size tanınan haklar nelerdir? Detaylı bilgilendirme için okuyun."
        />
        <link rel="canonical" href="/" />
      </Helmet>
      <div className="sm:w-full  sm:mx-auto mt-10 ">
        <h1 className="text-center font-extrabold text-red-900 text-3xl">
          Kalıcı Engel Tazminatı
        </h1>
      </div>
      <div className="sm:mx-96 mx-2 text-gray-700 font-light text-lg">
        <p className="mt-8">
          Trafik kazası sonrası kalıcı engel tazminatı, bir trafik kazası
          sonucunda yaralanan kişinin hayatında kalıcı bir engelin oluşması
          durumunda, bu engelin yol açtığı zararların tazmin edilmesini
          amaçlayan bir tazminat türüdür. Hukukumuzda bu tazminat, trafik kazası
          sonucunda kalıcı bir sakatlık veya engel yaşayan kişilere tanınan
          haklardan biridir ve kusurlu aracın zorunlu trafik sigortası
          tarafından tazmin edilir.
        </p>
        <p className="mt-8">
          Kalıcı engel tazminatı, trafik kazası sonucunda meydana gelen
          sakatlığın, kişinin hayatını kalıcı olarak etkilemesi durumunda
          ödenir. Bu sakatlık, bir uzvun kaybı, fonksiyon kaybı, hareket
          kısıtlılığı veya herhangi bir şekilde kalıcı bir engelin oluşması gibi
          durumları içerebilir.
        </p>

        <p className="mt-8">
          Kalıcı engel tazminatı, trafik kazasında zarar gören kişinin, oluşan
          kalıcı engelden dolayı yaşadığı fiziksel ve psikolojik sıkıntıların
          karşılanması amacıyla ödenir. Tazminat miktarı, zarar görenin yaşadığı
          engelin ciddiyeti, etkileri, mesleki faaliyetlerini ne ölçüde
          etkilediği, hayat kalitesindeki değişiklikler ve diğer faktörlere
          bağlı olarak belirlenir.
        </p>

        <p className="mt-8">
          Kalıcı engel tazminatı, zarar görenin yaşadığı engel nedeniyle
          hayatında meydana gelen ek masrafların, tedavi giderlerinin,
          rehabilitasyon sürecinin ve engelin yol açtığı diğer maddi zararların
          karşılanmasını hedefler. Ayrıca, zarar görenin yaşadığı acı ve
          sıkıntıların telafi edilmesi ve yaşam standartlarının korunması da
          amaçlanır.
        </p>
        <p className="mt-8">
          Trafik kazası sonrası kalıcı engel tazminatı talebi için zarar
          görenin, trafik kazasından kaynaklanan sakatlığın kalıcı olduğunu ve
          bu sakatlığın trafik kazasının bir sonucu olduğunu kanıtlaması
          gerekmektedir. Bu kanıtlar, tıbbi raporlar, uzman görüşleri, tedavi
          süreçleri ve diğer delillerle desteklenir.
        </p>
        <p className="mt-8">
          Trafik kazası sonrası kalıcı engel tazminatı, trafik kazalarının yol
          açtığı kalıcı etkilerin hafifletilmesi, zarar görenin haklarının
          korunması ve adaletin sağlanması amacıyla önemli bir yasal araçtır. Bu
          tazminat, zarar görenin yaşadığı engelin etkilerini azaltmayı ve
          hayatını sürdürebilmesini sağlamayı hedefler. Tazminat miktarı,
          mahkeme tarafından zarar görenin durumuna ve kaybettiği yeteneklerine
          göre belirlenir.
        </p>
      </div>
    </div>
  );
}
